import React, { useContext } from 'react'
import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import NbciUsInvoiceKeys from '../../../../constants/locale/key/NbciUsInvoice'
import CngField from '../../../../components/cngcomponents/CngField'
import TinyChip from '../../../../components/aciacehighway/TinyChip'
import { USInvoiceLookupsContext } from '../../lookups/USInvoiceLookupsContext'
import { Grid, Typography, useTheme } from '@material-ui/core'
import _ from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function PackingListFormViewContent(props) {
  const { packingList } = props

  const { getLookupValue } = useContext(USInvoiceLookupsContext)
  const theme = useTheme()
  const { translate } = useTranslation(Namespace.NBCI_US_INVOICE)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    const otherRefNo = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.OTHER_REF_NO
    )
    const responsibleForCustoms = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.RESPONSIBLE_FOR_CUSTOMS
    )
    const instructionsToBroker = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.INSTRUCTIONS_TO_BROKER
    )
    const containerized = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.CONTAINERIZED
    )
    const billChargesTo = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.BILL_CHARGES_TO
    )
    const portOfLoading = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.PORT_OF_LOADING
    )
    const flightDetails = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.FLIGHT_DETAILS
    )
    const placeOfDelivery = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.PLACE_OF_DELIVERY
    )
    const specialInstructions = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.PackingList.SPECIAL_INSTRUCTIONS
    )

    return {
      otherRefNo,
      responsibleForCustoms,
      instructionsToBroker,
      containerized,
      billChargesTo,
      portOfLoading,
      flightDetails,
      placeOfDelivery,
      specialInstructions
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.otherRefNo}>
          {packingList.otherRefNo}
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.portOfLoading}>
          <Typography component='div' variant='inherit'>
            {getLookupValue('country', packingList.portOfLoading)}
            <TinyChip label={packingList.portOfLoading} variant='outlined' />
          </Typography>
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.responsibleForCustoms}>
          {packingList.responsibleForCustoms}
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.flightDetails}>
          {packingList.flightDetails}
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.instructionsToBroker}>
          {getLookupValue('instructionsToBroker', packingList.instructionsToBroker)}
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.placeOfDelivery}>
          {packingList.placeOfDelivery}
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.billChargesTo}>
          {getLookupValue('billChargesTo', packingList.billChargesTo)}
        </CngField>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Grid container spacing={2}>
          <Grid item xs='auto'>
            <FontAwesomeIcon
              color={
                packingList.containerized === 'Y'
                  ? theme.palette.primary.main
                  : theme.palette.error.main
              }
              fixedWidth
              icon={['fal', packingList.containerized === 'Y' ? 'check' : 'ban']}
            />
          </Grid>
          <Grid item xs>
            {translatedTextsObject.containerized}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CngField label={translatedTextsObject.specialInstructions}>
          {packingList.specialInstructions}
        </CngField>
      </Grid>
    </Grid>
  )
}

export default PackingListFormViewContent
